import { Module } from "vuex";
import { RootState, MypageState } from "@/types/mypage";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state: MypageState = {
  addRecipeResult: null,
  deleteRecipeResult: null,
  recentFavoriteRecipeList: null,
  favoriteRecipeList: null,
  folderList: null,
  folderRecipeList: null,
  registFolderResult: null,
  renameFolderResult: null,
  deleteFolderResult: null,
  addFolderRecipeResult: null,
  deleteFolderRecipeResult: null,
  folderMoveResult: null,
  folderName: null,
  selectedTab: 1,
  favoriteFoodList: null,
  inquiryStatus: null,
  foodsRanking: null,
  userRanking: null,
  topHistoryRecipe: null,
  historyRecipe: null,
  monthlyUsedRanking: null,
  personalMonthlyUsedFoodsRanking: null,
  personalMonthlyDisposedFoodsRanking: null,
  nationwideMonthlyUsedFoodsRanking: null,
  nationwideMonthlyDisposedFoodsRanking: null,
  selectedMonthIndex: null
};

export const mypage: Module<MypageState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
